import { Skeleton } from '@mantine/core'

/**
 * Layout-family skeleton for the contract-analysis workbench (ADR 0027): a document page
 * beside a right rail, holding the two-zone shape while the route loader fetches the
 * contract, its PDF and its clauses.
 */
export function DocumentWorkbenchSkeleton() {
  return (
    <div
      data-testid="document-workbench-loading"
      role="status"
      aria-busy="true"
      aria-label="Loading contract"
      style={{ display: 'flex', gap: '1rem', height: '100%', minHeight: '60vh', padding: '1rem' }}
    >
      {/* The document pane: a top bar and a page-shaped block. */}
      <div style={{ flex: 3, display: 'flex', flexDirection: 'column', gap: '0.75rem', minWidth: 0 }}>
        <Skeleton height={40} radius="var(--radius-sm)" />
        <Skeleton height="70vh" radius="var(--radius-sm)" />
      </div>
      {/* The right rail: a stack of clause-card-shaped blocks. */}
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '0.75rem', minWidth: '16rem' }}>
        <Skeleton height={32} width="60%" radius="var(--radius-sm)" />
        {Array.from({ length: 5 }, (_, i) => (
          <Skeleton key={i} height={72} radius="var(--radius-sm)" />
        ))}
      </div>
    </div>
  )
}
